import React, { useRef } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import ModalInfo from "views/Checkout/Modais/ModalInfo";
import InputMask from 'react-input-mask';
import { Autocomplete, TextField, FormControl } from "@mui/material";
import { useCadastroMultaNaoAcompanhadaStore } from "stores/cadastroMultaNaoAcompanhadaStore";
import { FormMultaNaoAcompanhadaButtons } from "../FormMultaNaoAcompanhadaButtons";
import { useState } from "react";

const generoOptions = [
  { label: "Masculino", value: "M" },
  { label: "Feminino", value: "F" }
];

const enderecoCache = new Map();

export function FormMultaNaoAcompanhadaDadosPessoais({ isActive }) {
  const cadastroStore = useCadastroMultaNaoAcompanhadaStore();
  const [endereco, setEndereco] = useState(cadastroStore.enderecoCompletos ?? '');
  const [cep, setCep] = useState(cadastroStore.cep ?? '');
  const [numero, setNumero] = useState(cadastroStore.numero ?? '');
  const [complemento, setComplemento] = useState(cadastroStore.complemento ?? '');

  const onSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const genero = formData.get("sexo");
    const generoValue = generoOptions.find(option => option.label === genero)?.value;

    const formValues = {
      sexo: generoValue,
      nomeCompletoDefesa: formData.get("nomeCompletoDefesa"),
      cpfDefesa: formData.get("cpfDefesa"),
      telefoneContato: formData.get("telefoneContato"),
      cep: formData.get("cep"),
      numero: formData.get("numero"),
      complemento: formData.get("complemento"),
      enderecoCompletos: formData.get("enderecoCompletos"),
    };
    
    cadastroStore.setDadosBasicos(formValues);
    cadastroStore.goToNext();
  };

  const fetchAddress = async (cep) => {
    if (enderecoCache.has(cep)) {
      return enderecoCache.get(cep);
    }

    const res = await fetch(`https://brasilapi.com.br/api/cep/v1/${cep}`);
    const data = await res.json();

    enderecoCache.set(cep, data);
    return data;
  };

  function formatarEnderecoNumero(enderecoNumero) {
    const isNumeric = !Number.isNaN(Number.parseInt(enderecoNumero));
    if (isNumeric) {
      return `Nº ${enderecoNumero}`;
    }

    return enderecoNumero;
  }

  const updateEnderecoCompleto = async (novoCep = cep, novoNumero = numero, novoComplemento = complemento) => {
    const cepLimpo = novoCep.replace(/\D/g, '');
    console.log("a", cepLimpo)
    if (cepLimpo.length < 8) {
      return;
    }
    
    const address = await fetchAddress(cepLimpo);
    
    const addressParts = [
      address.street,
      formatarEnderecoNumero(novoNumero),
      novoComplemento,
      address.neighborhood,
      address.city,
      address.state,
      "CEP: " + cepLimpo,
    ];

    const enderecoCompleto = addressParts
      .filter(part => typeof part === "string" && part.trim().length > 0)
      .join(", ");

    setEndereco(enderecoCompleto);

    return enderecoCompleto;
  };

  const handleCepChange = async (e) => {
    try {
      const newCep = e.target.value;
      setCep(newCep);
      await updateEnderecoCompleto(newCep);
    } catch (e) {
      console.warn(e);
    }
  }

  const handleNumeroChange = async (e) => {
    try {
      const novoNumero = e.target.value;
      setNumero(novoNumero);
      await updateEnderecoCompleto(cep, novoNumero, complemento);
    } catch (e) {
      console.warn(e);
    }
  }

  const handleComplementoChange = async (e) => {
    try {
      const novoComplemento = e.target.value;
      setComplemento(novoComplemento);
      await updateEnderecoCompleto(cep, numero, novoComplemento);
    } catch (e) {
      console.warn(e);
    }
  }

  return (
    <form onSubmit={onSubmit}>
      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <ModalInfo imagem={""} label="Gênero" />
          <FormControl style={{ marginTop: 26, width: "100%" }}>
            <Autocomplete
              id="Sexo"
              options={generoOptions}
              getOptionLabel={(option) => option.label} // Exibe os rótulos corretos
              defaultValue={generoOptions.find(option => option.value === cadastroStore.sexo)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Selecione o gênero"
                  name="sexo"
                  required
                />
              )}
            />
          </FormControl>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <ModalInfo imagem={""} label="Nome" />
          <TextField
            id="NomeCompletoDefesa"
            name="nomeCompletoDefesa"
            defaultValue={cadastroStore.nomeCompletoDefesa}
            label={`Nome completo para quem será feita a defesa (nome que sairá na petição)`}
            margin="dense"
            fullWidth
            required
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={""} label="CPF" />
          <InputMask
            mask="999.999.999-99"
            name="cpfDefesa"
            defaultValue={cadastroStore.cpfDefesa}
          >
            {() => (
              <TextField
                id="CpfDefesa"
                label="CPF para quem será feita a defesa (CPF que sairá na petição)"
                margin="dense"
                name="cpfDefesa"
                fullWidth
                inputProps={{ maxLength: 18 }}
                required
              />
            )}
          </InputMask>

        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={""} label="Telefone" />
          <InputMask
            mask="(99) 99999-9999"
            defaultValue={cadastroStore.telefoneContato}
          >
            {() => (
              <TextField
                id="TelefoneContato"
                label="Telefone de contato"
                margin="dense"
                name="telefoneContato"
                fullWidth
                inputProps={{ maxLength: 18 }}
                required
              />
            )}
          </InputMask>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={""} label="CEP" />

          <InputMask
            mask="99999-999"
            defaultValue={cadastroStore.cep}
            onChange={handleCepChange}
          >
            {() => (
              <TextField
                id="Cep"
                label="CEP"
                margin="dense"
                name="cep"
                fullWidth
                inputProps={{ maxLength: 18 }}
                required
              />
            )}
          </InputMask>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={""} label="Número" />
          <TextField
            id="numero"
            label="Número"
            margin="dense"
            name="numero"
            fullWidth
            inputProps={{ maxLength: 18 }}
            onChange={handleNumeroChange}
            defaultValue={cadastroStore.numero}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={""} label="Complemento" />
          <TextField
            id="complemento"
            label="Complemento"
            margin="dense"
            name="complemento"
            fullWidth
            inputProps={{ maxLength: 18 }}
            onChange={handleComplementoChange}
            defaultValue={cadastroStore.complemento}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={""} label="Endereço (Ex.: Rua Um Dois Três, 10, apto 307 - Realengo - Rio de Janeiro/RJ)" />
          <TextField
            id="EnderecoCompletos"
            name="enderecoCompletos"
            value={endereco}
            onChange={(e) => setEndereco(e.target.value)}
            label={`Endereço completo`}
            margin="dense"
            helperText=""
            fullWidth
            required
          />
        </GridItem>
      </GridContainer>

      <FormMultaNaoAcompanhadaButtons />
    </form>
  );
}